import { logCoralogix } from '@sunflower-games/coralogix-rum';

import { resolveFlag } from '../services/launchDarkly';

const consoleProxy = new Proxy(console, {
  get: (target, propKey) => {
    if (propKey === 'log' || propKey === 'warn' || propKey === 'error') {
      return (message: string, ...args: any[]) => {
        const stack = new Error().stack?.split('\n')?.[3]?.split('at ')?.[1]?.trim(); // Adjust stack level if needed
        if (stack) {
          return target[propKey](stack, message, ...args);
        } else {
          return target[propKey](message, ...args);
        }
      };
    }

    return target[propKey as keyof typeof console];
  },
});

export function devLog(message: string, ...args: any[]) {
  const enableClientLogs = resolveFlag('enable_client_logs', false);
  if (enableClientLogs) {
    consoleProxy.log(message, ...args);

    if (window.newrelic) {
      window.newrelic.log(message, {
        level: 'info',
        customAttributes: {
          message,
          args,
          context: 'devLog',
        },
      });
    }

    if (window.CoralogixRum) {
      // Debug severity → sampled by the RUM wrapper, not kept on the
      // always-retained Info channel reserved for named business events.
      logCoralogix.debug(message, {
        message,
        args,
        context: 'devLog',
      });
    }
  }
}

export function devError(message: string, ...args: any[]) {
  const enableClientLogs = resolveFlag('enable_client_logs', false);
  if (enableClientLogs) {
    consoleProxy.error(message, ...args);

    if (window.newrelic) {
      window.newrelic.log(message, {
        level: 'error',
        customAttributes: {
          message,
          args,
          context: 'devError',
        },
      });

      window.newrelic.noticeError(new Error(message), {
        message,
        args,
        context: 'devError',
      });
    }

    if (window.CoralogixRum) {
      // Debug severity → sampled, keeps dev diagnostics off the kept channel.
      logCoralogix.debug(message, {
        message,
        args,
        context: 'devError',
      });
    }
  }
}

export function devWarn(message: string, ...args: any[]) {
  const enableClientLogs = resolveFlag('enable_client_logs', false);
  if (enableClientLogs) {
    consoleProxy.warn(message, ...args);

    if (window.newrelic) {
      window.newrelic.log(message, {
        level: 'warn',
        customAttributes: {
          message,
          args,
          context: 'devWarn',
        },
      });
    }

    if (window.CoralogixRum) {
      // Debug severity → sampled, keeps dev diagnostics off the kept channel.
      logCoralogix.debug(message, {
        message,
        args,
        context: 'devWarn',
      });
    }
  }
}
